import { COLOR } from './../../utils';
export default {
  data() {
    return {
      dialogVisible: false,
      colorList: [],
      color: '',
      type: ''
    };
  },
  methods: {
    init(val, type) {
      this.color = val;
      this.type = type;
      this.colorList = COLOR[type];
      this.dialogVisible = true;
    },
    colorFun(val) {
      this.color = val.key;
    },
    handleSure() {
      this.$emit('ok', this.color, this.type);
    }
  }
};